export default __webpack_public_path__ + "media/fantastic-end-skirt-from-the-book-of-death-rhymes-72723.867c2371.mp3";